import { RootState } from '../../../../../../init-store';

export const getBroadcastViewStatus = (state: RootState) => state.broadcastView?.status;

export const selectIsUgcLiveBroadcast = (state: RootState) => {
    const ugcLive = state.broadcastView.ugc_live;
    /** В случае undefined считаем, что старое API */
    return ugcLive === undefined || state.broadcastView.ugc_live;
};

export const getBroadcastLiveData = (state: RootState) => {
    const {
        stream_uri: streamUrl,
        player_url: playerUrl,
        caption,
        description,
        broadcast_chat_path,
        start_event_time,
        ugc_live_status: ugcLiveStatus,
    } = state.broadcastView || {};

    const broadcastData = {
        strmPlayerUrl: playerUrl || '',
        streamUrlPlayer: '',
        streamUrlJson: '',
        caption,
        description,
        chatId: broadcast_chat_path,
        startEventTime: typeof start_event_time === 'number' ? start_event_time * 1000 : undefined,
        ugcLiveStatus,
    };

    if (streamUrl) {
        const streamUrlPlayer = new URL(streamUrl);
        streamUrlPlayer.searchParams.append('from', 'telemost');

        const { environment, vhLiveHost } = state.config;
        if (['testing', 'development'].includes(environment)) {
            streamUrlPlayer.searchParams.append('api_host', `${vhLiveHost}/live`);
        }
        broadcastData.streamUrlPlayer = streamUrlPlayer.toString();
        broadcastData.streamUrlJson = `${streamUrl}.json`;
    }

    if (playerUrl) {
        const playerUrlObject = new URL(playerUrl);
        playerUrlObject.searchParams.append('primary_color', '33f583'); // --orb-surface-brand
        broadcastData.strmPlayerUrl = playerUrlObject.toString();
    }

    return broadcastData;
};

export const broadcastWithChat = (state: RootState) => {
    const { chatId } = getBroadcastLiveData(state);
    return Boolean(chatId);
};

export const getCountdownStartTime = (state: RootState) => {
    const { startEventTime } = getBroadcastLiveData(state);
    if (typeof startEventTime === 'number') {
        const time = startEventTime - Date.now();
        return time < 0 ? 0 : time;
    }
};

export interface BroadcastInfoData {
    viewers?: number;
    createdByDisplayName?: string;
    startedAt?: number;
}

export const getBroadcastInfo = (state: RootState) => {
    const { viewers, started_at, display_name } = state.broadcastView || {};
    const info: BroadcastInfoData = {};

    if (typeof viewers === 'number') {
        info.viewers = viewers;
    }

    if (started_at) {
        info.startedAt = started_at;
    }

    if (display_name) {
        info.createdByDisplayName = display_name;
    }

    if (Object.keys(info).length !== 0) {
        return info;
    }
    return null;
};

export const selectWasBroadcastPlayerViewingEnded = (state: RootState) =>
    Boolean(state.broadcastView.wasPlayerViewingEnded);

export const selectBroadcastEndedAt = (state: RootState) => state.broadcastView.ended_at;
